module.exports = __webpack_public_path__ + "img/bg.b44e49c7.png";